exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.additive-tabs[data-v-43562aa0]{\n  padding: 12px;\n}\n", ""]);

// exports
